<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix topper">
			<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
			<div class="col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264_1-01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264_1.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264.webm" type='video/webm' />
				</video>
			</div>
		</div>
		<div class="clearfix grid">
			<production-quote id="bestPictureProdQuote1" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote1"></production-quote>
			<div class="col-xs-12 col-md-6 col-md-pull-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_picture_block_1.jpg" alt="Three Billboards"></div>
		</div>
		<div class="clearfix grid">
			<production-quote id="bestPictureProdQuote2" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote2"></production-quote>
			<div class="col-xs-12 col-md-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_picture_block_2.jpg" alt="Three Billboards">
			</div>
		</div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-picture',
	data: function() {
		return {
			heroContent: {
				"image": "best-picture-3b-lg",
				"mobileImage": "best-picture-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Picture",
				"crewTitle": "Produced By",
				"subHeader": ['GRAHAM BROADBENT', 'PETE CZERNIN', 'MARTIN McDONAGH'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Director',
				clickThruPath: ''
			},
			criticSlider1: [{
				text: '&#9733; &#9733; &#9733; &#9733;<br />A renegade masterpiece that will get you good.',
				author: '- ROLLING STONE'
			}, {
				text: '&#9733; &#9733; &#9733; &#9733;<br />A darkly comic drama expertly structured with a rousing narrative.',
				author: '- USA TODAY'
			}, {
				text: 'A towering achievement. The best yet Martin McDonagh.',
				author: '- NYPost'
			}, {
				text: 'A Gut-Twisting Cinder-Black Comedy.',
				author: '- The Telegraph'
			}],
			productionQuote1: {
				text: "I think there’s something quite hopeful about the film in Mildred’s single-mindedness and also in Willoughby’s decency. I hope audiences will be moved and amused and feel they were just told a rich and somewhat unexpected type of story.",
				author: "- Martin McDonagh"
			},
			productionQuote2: {
				text: "It was always a given that this story would be funny, because it was already so funny on the page and we had such terrific actors. But as we made the film, Martin was so careful to protect the beautiful sadness and the love of humanity in the film, and that’s what brings it to another level.",
				author: "- Producer Graham Broadbent"
			}
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>


// WEBPACK FOOTER //
// BestPicture.vue?0d3f78b9